export const DEFAULT_NEWSLETTER_TAG = 'source-site-newsletter';
export const GET_INVOLVED_TAG = 'source-get-involved';
/** Master List Updated September, 2019 — Contact Us + Join Our Mailing List (LLSU2-157). */
export const WEEKLY_BRIEF_TAG = 'Weekly Brief Tag';
export const MASTER_AUDIENCE_LIST_ID = '46eca3db3b';

export function normalizeMailchimpTag(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return raw
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9._-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/** CMS mailchimpTag is sent to Mailchimp as typed. */
export function exactMailchimpTag(value) {
  return String(value || '').trim();
}

/**
 * Always keep a source tag. CMS Mailchimp tag wins for the context tag;
 * otherwise project/program/event pages use `{kind}-{slug}`.
 */
export function resolveNewsletterTags({ mailchimpTag, slug, kind, source } = {}) {
  const sourceTag = normalizeMailchimpTag(source) || DEFAULT_NEWSLETTER_TAG;
  const custom = exactMailchimpTag(mailchimpTag);
  if (custom) return [...new Set([sourceTag, custom])];
  const prefix = normalizeMailchimpTag(kind);
  const slugTag = normalizeMailchimpTag(slug);
  if (prefix && slugTag) return [...new Set([sourceTag, `${prefix}-${slugTag}`])];
  return [sourceTag];
}

export function resolveMailingListTags({ mailchimpTag } = {}) {
  return resolveNewsletterTags({
    mailchimpTag: mailchimpTag || WEEKLY_BRIEF_TAG,
    source: GET_INVOLVED_TAG,
  });
}
